<button class="td-wb-modal-close-button"
        tdWbIconButton
        tdWbIconButtonShape="circle"
        tdWbIconButtonSize="small"
        [tdWbIconButtonBackground]="buttonBackground()"
        [attr.aria-label]="ariaLabel() | translate"
        [tdWbFocus]="autoFocus()"
        [tdWbFocusDelay]="0"
        [tdWbModalClose]="reason()">
  <td-wb-icon iconId="close--small"
              size="18"
              (click)="close()"/>
</button>
